import { Navigate, RouteObject } from "react-router-dom";
import { ManagementHomePage } from "./pages";
import {
  UsersPage,
  ClientsPage,
  ComplexesPage,
  StructuresPage,
  LicensesPage,
  LogPage,
  ReleaseNotesPage,
  TermsOfUsePage,
  PrivacyPolicyPage,
} from "./features";

export const managementRoutes: RouteObject[] = [
  {
    path: "",
    element: <ManagementHomePage />,
    children: [
      {
        index: true,
        element: <Navigate to="users" replace />,
      },
      {
        path: "users",
        element: <UsersPage />,
      },
      {
        path: "clients",
        element: <ClientsPage />,
      },
      {
        path: "complexes",
        element: <ComplexesPage />,
      },
      {
        path: "structures",
        element: <StructuresPage />,
      },
      {
        path: "licenses",
        element: <LicensesPage />,
      },
      {
        path: "log",
        element: <LogPage />,
      },
      {
        path: "releaseNotes",
        element: <ReleaseNotesPage />,
      },
      {
        path: "termsOfUse",
        element: <TermsOfUsePage />,
      },
      {
        path: "privacyPolicy",
        element: <PrivacyPolicyPage />,
      },
    ],
  },
];
